var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14208 0.125H3.85792L0.125 3.85792V9.14208L3.85792 12.875H9.14208L12.875 9.14208V3.85792L9.14208 0.125ZM10.0417 9.14917L9.14917 10.0417L6.5 7.3925L3.85083 10.0417L2.95833 9.14917L5.6075 6.5L2.95833 3.85083L3.85083 2.95833L6.5 5.6075L9.14917 2.95833L10.0417 3.85083L7.3925 6.5L10.0417 9.14917Z",
    fill: "#BA1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7ddca58c.svg";
export { ForwardRef as ReactComponent };